import * as constants from './constants';

const defaultState = {
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.USER_INFO:
            return {...state, modifyUserInfo: action.value}
        default:
            return state;
    }
}